import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  Card,
  CardMedia,
  CardContent,
  CircularProgress,
} from "@mui/material";
import SensorOccupiedIcon from "@mui/icons-material/SensorOccupied";
import TelegramIcon from "@mui/icons-material/Telegram";

export default function ManageSupport() {
  const [imageLoaded, setImageLoaded] = useState(false); // حالة لتحقق تحميل الصورة

  return (
    <div
      dir="rtl"
      style={{
        backgroundColor: "#272727",
        color: "white",
        minHeight: "70vh",
        padding: "40px 20px",
        marginTop: "6%",
        fontFamily: "'Changa', sans-serif",
      }}
    >
      {/* العنوان الرئيسي */}
      <Box
        sx={{
          textAlign: "center",
          marginBottom: "20px",
        }}
      >
        <SensorOccupiedIcon sx={{ fontSize: 60, color: "#e6e6e6" }} />
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#e6e6e6" }}>
          الدعم الفني
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{ color: "#bdbdbd", marginTop: "10px" }}
        >
          أهلاً بك! إذا واجهت أي مشكلة، لا تتردد في التواصل معي.
        </Typography>
      </Box>

      {/* أقسام الدعم الفني */}
      <Grid container spacing={4} justifyContent="center" direction="column">
        {/* القسم الأول: تواصل معنا */}
        <Grid item xs={12}>
          <Card
            sx={{
              backgroundColor: "#333333",
              color: "white",
              textAlign: "center",
              borderRadius: "15px",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
              padding: "15px",
              width: "50%",
              margin: "auto",
            }}
          >
            {/* عرض رسالة تحميل أثناء تحميل الصورة */}
            {!imageLoaded && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "150px",
                }}
              >
                <CircularProgress color="primary" />
              </Box>
            )}

            <CardMedia
              component="img"
              alt="تواصل معنا"
              height="150"
              image="\images\support.webp" // استبدل الصورة برابط حقيقي
              sx={{
                objectFit: "contain",
                display: imageLoaded ? "block" : "none", // إخفاء الصورة حتى تحميلها
              }}
              onLoad={() => setImageLoaded(true)} // عند تحميل الصورة
            />
            <CardContent>
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "#e6e6e6" }}
              >
                تواصل معي
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  marginBottom: "15px",
                  color: "#bdbdbd",
                  marginTop: "10px",
                }}
              >
                يمكنك مراسلتي عبر التليجرام إذا كنت بحاجة إلى أي مساعدة أو لديك
                استفسار.
              </Typography>
              <Button
                href="https://t.me/faisalfahad0"
                target="_blank"
                variant="contained"
                startIcon={<TelegramIcon />}
                sx={{
                  backgroundColor: "#e6e6e6",
                  color: "#272727",
                  fontWeight: "bold",
                  padding: "8px 15px",
                  fontSize: "14px",
                  textTransform: "none",
                  borderRadius: "20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  "&:hover": {
                    backgroundColor: "#d6d6d6",
                  },
                }}
              >
                تواصل عبر التليجرام
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}
